import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { JobPost } from "@/features/job-post/forms/job-post";
import { z } from "zod";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/jobs/post/create/",
)({
  component: CreateJobPostingPage,
  validateSearch: z.object({
    id: z.string().optional(),
  }),
});

function CreateJobPostingPage() {
  return <JobPost />;
}
